import { showLoading, showError, setAnswer, setSuggestedQuestions } from "../features/queryAnsSlice";

const answerEndpoint = "https://flask.brlps.in/response";
const cancelEndpoint = "https://flask.brlps.in/cancel";

let currentController = null;
let lastRequestId = null;

export const abortCurrentQuery = async () => {
  if (currentController) {
    currentController.abort();
    currentController = null;
    console.log("Query fetch aborted");
  }

  if (lastRequestId) {
    console.log(`Notifying backend to cancel request: ${lastRequestId}`);
    try {
      await fetch(cancelEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ requestId: lastRequestId })
      });
    } catch (e) {
      console.warn("Failed to notify backend about cancellation:", e);
    }
  }
};

export const fetchAnswerMiddleware = (query, requestId) => {
  console.log("fetchmiddleware called for:", query, "id:", requestId);
  return async (dispatch) => {
    try {
      // Abort previous if any
      await abortCurrentQuery();

      currentController = new AbortController();
      lastRequestId = requestId;
      const { signal } = currentController;

      dispatch(showLoading());

      const resp = await fetch(answerEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ "question": query, "requestId": requestId }),
        signal: signal
      });

      if (resp.ok) {
        const data = await resp.json();
        console.log("data is:", data);
        dispatch(setAnswer(data.response));

        // Dispatch suggested questions from response_list
        if (data.response_list && Array.isArray(data.response_list)) {
          dispatch(setSuggestedQuestions(data.response_list));
        } else {
          dispatch(setSuggestedQuestions([]));
        }
      } else {
        const data = await resp.json();
        const response = data.response;
        const suggestedQuestions = data.response_list;

        if (suggestedQuestions && Array.isArray(suggestedQuestions)) {
          dispatch(setSuggestedQuestions(suggestedQuestions));
        } else {
          dispatch(setSuggestedQuestions([]));
        }

        dispatch(setAnswer(response || ''));
        dispatch(showError());
      }

    } catch (err) {
      if (err.name === 'AbortError') {
        console.log('Fetch aborted by user');
        // Don't show error state for user-initiated abort
        return;
      }
      console.error("Error occurred:", err);
      dispatch(setAnswer(`${err.message}`));
      dispatch(showError());
      dispatch(setSuggestedQuestions([]));
    } finally {
      currentController = null;
    }
  };
};
